(function () {
  'use strict';

  /* ---------- image slots ---------- */
  function fillSlots(attr, map) {
    [].forEach.call(
      document.querySelectorAll('[' + attr + ']'),
      function (slot) {
        var src = (map || {})[slot.getAttribute(attr)];
        if (!src) return;

        var img = slot.querySelector('img');
        if (!img) return;

        img.onload = function () {
          slot.classList.add('has-img');
          img.classList.add('in');
        };

        img.onerror = function () {
          img.removeAttribute('src');
        };

        img.src = src;
      }
    );
  }

  fillSlots('data-case-slot', PEEPERLY.caseImages);
  fillSlots('data-model-slot', PEEPERLY.modelImages);


  /* ============================================================
     GIVEAWAY
     ============================================================ */

  (function () {
    var G = PEEPERLY.giveaway || {};

    var wrap = document.getElementById('tasks');
    var note = document.getElementById('task-note');
    var form = document.getElementById('give-form');
    var done = document.getElementById('give-done');
    var btn = document.getElementById('gv-submit');
    var nEl = document.getElementById('gv-name');
    var eEl = document.getElementById('gv-email');
    var hEl = document.getElementById('gv-handle');
    var pEl = document.getElementById('gv-phone');
    var ocEl = document.getElementById('gv-occupation');
    var cpEl = document.getElementById('gv-currentphone');
    var cityEl = document.getElementById('gv-city');
    var stateEl = document.getElementById('gv-state');
    var oEl = document.getElementById('gv-order');
    var copy = document.getElementById('gv-copy');
    var link = document.getElementById('gv-link');
    var giveH = document.getElementById('give-h');
    var bonusBox = document.getElementById('bonus-box');
    var heardOpts = document.getElementById('gf-heard-opts');
    var heardWhereWrap = document.getElementById('gf-heard-where');
    var hwEl = document.getElementById('gv-heard-where');
    var heardValue = '';

    if (!wrap) return;

    var KEY = 'peeperly_giveaway_v3';
    var TOTAL = wrap.querySelectorAll('.task').length;

    var post = G.postUrl || G.instagram;

    [
      ['lnk-yt', G.youtube],
      ['lnk-sc', G.snapchat],
      ['lnk-pin', G.pinterest],
      ['lnk-post1', post],
      ['lnk-post2', post]
    ].forEach(function (pair) {
      var el = document.getElementById(pair[0]);

      if (el && pair[1]) {
        el.href = pair[1];
      }
    });

    function ticked() {
      return wrap.querySelectorAll('.task.done').length;
    }

    function refresh() {
      var n = ticked();
      var left = TOTAL - n;

      btn.disabled = n < TOTAL;

      note.textContent =
        left === 0
          ? 'All done. Add your details and you are in.'
          : left === 1
          ? 'One more to go.'
          : left + ' more to go.';
    }

    function toggle(t) {
      var on = !t.classList.contains('done');

      t.classList.toggle('done', on);
      t.setAttribute(
        'aria-checked',
        on ? 'true' : 'false'
      );

      refresh();
    }

    wrap.addEventListener('click', function (e) {
      if (e.target.closest('.go')) return;

      var t = e.target.closest('.task');

      if (t) {
        toggle(t);
      }
    });

    wrap.addEventListener('keydown', function (e) {
      if (e.key !== ' ' && e.key !== 'Enter') return;

      var t = e.target.closest('.task');

      if (t) {
        e.preventDefault();
        toggle(t);
      }
    });

    [].forEach.call(
      wrap.querySelectorAll('.go'),
      function (a) {
        a.addEventListener('click', function () {
          var t = a.closest('.task');

          if (
            t &&
            !t.classList.contains('done')
          ) {
            setTimeout(function () {
              toggle(t);
            }, 400);
          }
        });
      }
    );

    function makeCode(seed) {
      var h = 0;

      for (var i = 0; i < seed.length; i++) {
        h =
          ((h << 5) -
            h +
            seed.charCodeAt(i)) |
          0;
      }

      return (
        'PEEP' +
        Math.abs(h)
          .toString(36)
          .slice(0, 4)
          .toUpperCase()
      );
    }

    function hideTasksArea() {
      // Everything that should disappear once the giveaway entry is
      // submitted: the "Do all six" header, the task checklist, its
      // helper note, and the previous-customer bonus box. Only the
      // "You are in the draw" success card remains visible.
      if (giveH) giveH.style.display = 'none';
      if (wrap) wrap.style.display = 'none';
      if (note) note.style.display = 'none';
      if (bonusBox) bonusBox.style.display = 'none';
    }

    function entered(code, entries) {
      document.getElementById(
        'gv-code'
      ).textContent = code;

      link.value =
        location.origin +
        location.pathname +
        '?ref=' +
        code;

      document.getElementById(
        'gv-count'
      ).textContent =
        entries +
        (entries === 1
          ? ' entry'
          : ' entries') +
        ' so far. Winner announced ' +
        (G.resultsOn ||
          'on the closing date') +
        '.';

      form.hidden = true;
      done.hidden = false;

      hideTasksArea();
    }

    try {
      var prev = JSON.parse(
        localStorage.getItem(KEY) || 'null'
      );

      if (prev && prev.code) {
        entered(
          prev.code,
          prev.entries
        );
      }
    } catch (e) {}

    function bad(id, is) {
      var el =
        document.getElementById(id);

      if (el) {
        el.classList.toggle(
          'bad',
          is
        );
      }
    }

    /* ---------- heard-before pill options ---------- */
    if (heardOpts) {
      heardOpts.addEventListener('click', function (e) {
        var b = e.target.closest('.gf-opt');
        if (!b) return;

        heardOpts.querySelectorAll('.gf-opt').forEach(function (o) {
          o.classList.remove('sel');
        });
        b.classList.add('sel');
        heardValue = b.getAttribute('data-value');
        heardOpts.classList.remove('bad');

        if (heardValue === 'Yes') {
          heardWhereWrap.style.display = 'block';
        } else {
          heardWhereWrap.style.display = 'none';
          bad('gf-heard-where', false);
          if (hwEl) hwEl.value = '';
        }
      });
    }

    if (hwEl) {
      hwEl.addEventListener('input', function () {
        bad('gf-heard-where', false);
      });
    }

    if (eEl) {
      eEl.addEventListener('input', function () {
        bad('gf-email', false);
      });
    }

    if (ocEl) {
      ocEl.addEventListener('change', function () {
        bad('gf-occupation', false);
      });
    }

    if (cpEl) {
      cpEl.addEventListener('input', function () {
        bad('gf-currentphone', false);
      });
    }

    if (cityEl) {
      cityEl.addEventListener('input', function () {
        bad('gf-city', false);
      });
    }

    if (stateEl) {
      stateEl.addEventListener('input', function () {
        bad('gf-state', false);
      });
    }

    btn.addEventListener(
      'click',
      function () {
        var nm = nEl.value.trim();

        var hd = hEl.value
          .trim()
          .replace(/^@/, '');

        var ph = pEl.value.replace(
          /\D/g,
          ''
        );

        var em = eEl ? eEl.value.trim() : '';
        var oc = ocEl ? ocEl.value : '';
        var cp = cpEl ? cpEl.value.trim() : '';
        var city = cityEl ? cityEl.value.trim() : '';
        var st = stateEl ? stateEl.value.trim() : '';

        var ok = true;

        bad('gf-name', !nm);

        if (!nm) {
          ok = false;
        }

        bad('gf-handle', !hd);

        if (!hd) {
          ok = false;
        }

        var phOk =
          /^[6-9]\d{9}$/.test(ph);

        bad('gf-phone', !phOk);

        if (!phOk) {
          ok = false;
        }

        var emOk = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(em);

        bad('gf-email', !emOk);

        if (!emOk) {
          ok = false;
        }

        bad('gf-occupation', !oc);

        if (!oc) {
          ok = false;
        }

        bad('gf-currentphone', !cp);

        if (!cp) {
          ok = false;
        }

        bad('gf-city', !city);

        if (!city) {
          ok = false;
        }

        bad('gf-state', !st);

        if (!st) {
          ok = false;
        }

        if (!heardValue) {
          if (heardOpts) heardOpts.classList.add('bad');
          ok = false;
        } else if (heardOpts) {
          heardOpts.classList.remove('bad');
        }

        var hw = '';

        if (heardValue === 'Yes') {
          hw = hwEl ? hwEl.value.trim() : '';
          bad('gf-heard-where', !hw);

          if (!hw) {
            ok = false;
          }
        }

        if (!ok) return;

        btn.disabled = true;
        btn.textContent = 'Entering…';

        var code = makeCode(
          ph + hd.toLowerCase()
        );

        var order =
          oEl.value.trim();

        var entries =
          1 + (order ? 5 : 0);

        var params =
          new URLSearchParams(
            location.search
          );

        var row = {
          name: nm,
          email: em,
          instagram: '@' + hd,
          phone: ph,
          occupation: oc,
          currentPhone: cp,
          city: city,
          state: st,
          heardBefore: heardValue,
          heardWhere: hw,
          code: code,
          referredBy:
            params.get('ref') || '',
          orderNumber: order,
          baseEntries: entries,

          tasks: [].map.call(
            wrap.querySelectorAll(
              '.task'
            ),
            function (t) {
              return (
                t.getAttribute(
                  'data-task'
                ) +
                (
                  t.classList.contains(
                    'done'
                  )
                    ? ':yes'
                    : ':no'
                )
              );
            }
          ).join(' '),

          page: location.href,
          at: new Date().toISOString()
        };

        var finish = function () {
          try {
            localStorage.setItem(
              KEY,
              JSON.stringify({
                code: code,
                entries: entries
              })
            );
          } catch (e) {}

          if (window.fbq) {
            fbq('track', 'Lead', {
              content_name:
                'iPhone 18 giveaway entry'
            });
          }

          entered(code, entries);
        };

        if (!G.sheetEndpoint) {
          console.log(
            '[Peeperly] demo mode:',
            row
          );

          finish();
          return;
        }

        fetch(G.sheetEndpoint, {
          method: 'POST',
          body: JSON.stringify(row)
        })
          .catch(function (err) {
            console.error(
              '[Peeperly] giveaway POST failed',
              err
            );
          })
          .then(finish);
      }
    );

    pEl.addEventListener(
      'input',
      function () {
        var v =
          this.value.replace(
            /\D/g,
            ''
          );

        if (
          v.length > 10 &&
          v.slice(0, 2) === '91'
        ) {
          v = v.slice(2);
        }

        if (
          v.length > 10 &&
          v.charAt(0) === '0'
        ) {
          v = v.slice(1);
        }

        this.value =
          v.slice(0, 10);

        bad(
          'gf-phone',
          false
        );
      }
    );

    nEl.addEventListener(
      'input',
      function () {
        bad('gf-name', false);
      }
    );

    hEl.addEventListener(
      'input',
      function () {
        bad(
          'gf-handle',
          false
        );
      }
    );

    copy.addEventListener(
      'click',
      function () {
        link.select();
        link.setSelectionRange(
          0,
          99999
        );

        var mark = function () {
          copy.textContent =
            'Copied';

          setTimeout(
            function () {
              copy.textContent =
                'Copy';
            },
            1800
          );
        };

        if (
          navigator.clipboard
        ) {
          navigator.clipboard
            .writeText(link.value)
            .then(mark, mark);
        } else {
          try {
            document.execCommand(
              'copy'
            );
          } catch (e) {}

          mark();
        }
      }
    );

    refresh();
  })();


  /* ============================================================
     COUNTDOWN
     ============================================================ */

  var target =
    new Date(
      PEEPERLY.closesAt
    ).getTime();

  var stickyClock =
    document.getElementById(
      'sticky-clock'
    );

  var cdEl = {
    d: document.getElementById(
      'cd-d'
    ),
    h: document.getElementById(
      'cd-h'
    ),
    m: document.getElementById(
      'cd-m'
    ),
    s: document.getElementById(
      'cd-s'
    )
  };

  var pad = function (n) {
    return n < 10
      ? '0' + n
      : String(n);
  };

  var timerId;

  function tick() {
    var diff =
      target - Date.now();

    if (diff <= 0) {
      var band =
        document.getElementById(
          'cd'
        );

      if (band) {
        band.innerHTML =
          '<div class="u" style="min-width:auto;padding:12px 22px;">' +
          '<span class="n" style="font-size:20px;">Doors are open</span>' +
          '<span class="l">The drop is live</span>' +
          '</div>';
      }

      if (stickyClock) {
        stickyClock.textContent =
          'Live now';
      }

      clearInterval(timerId);
      return;
    }

    var d = Math.floor(
      diff / 864e5
    );

    var h = Math.floor(
      (diff % 864e5) / 36e5
    );

    var m = Math.floor(
      (diff % 36e5) / 6e4
    );

    var sec = Math.floor(
      (diff % 6e4) / 1e3
    );

    if (cdEl.d) {
      cdEl.d.textContent = pad(d);
      cdEl.h.textContent = pad(h);
      cdEl.m.textContent = pad(m);
      cdEl.s.textContent = pad(sec);
    }

    if (stickyClock) {
      stickyClock.textContent =
        d > 0
          ? 'Closes in ' +
            d +
            'd ' +
            h +
            'h'
          : 'Closes in ' +
            h +
            'h ' +
            m +
            'm';
    }
  }

  tick();

  timerId = setInterval(
    tick,
    1000
  );


  /* ============================================================
     BOOKING STATE
     ============================================================ */

  var DRAFT =
    'peeperly_prebook_v2';

  var state = {
    model: '',
    series: '',
    price: 0,
    wantsSet: false
  };

  try {
    var saved = JSON.parse(
      localStorage.getItem(
        DRAFT
      ) || '{}'
    );

    Object.keys(saved).forEach(
      function (k) {
        if (k in state) {
          state[k] = saved[k];
        }
      }
    );
  } catch (e) {}

  function save() {
    try {
      localStorage.setItem(
        DRAFT,
        JSON.stringify(state)
      );
    } catch (e) {}
  }

  var ov =
    document.getElementById(
      'ov'
    );

  var steps = [].slice.call(
    document.querySelectorAll(
      '.step'
    )
  );

  var bars = [].slice.call(
    document.querySelectorAll(
      '#m-steps i'
    )
  );

  var btnNext =
    document.getElementById(
      'm-next'
    );

  var btnBack =
    document.getElementById(
      'm-back'
    );

  var mSub =
    document.getElementById(
      'm-sub'
    );

  var cur = 1;

  var lastFocus = null;


  function money(n) {
    return (
      '₹' +
      Number(n).toLocaleString(
        'en-IN'
      )
    );
  }


  function paint(
    listId,
    value
  ) {
    var wrap =
      document.getElementById(
        listId
      );

    if (!wrap) return;

    [].forEach.call(
      wrap.querySelectorAll(
        '.opt-btn'
      ),
      function (b) {
        b.classList.toggle(
          'sel',
          b.getAttribute(
            'data-val'
          ) === value
        );
      }
    );
  }


  function fillSummary() {
    document.getElementById(
      's-model'
    ).textContent =
      state.model ||
      'Decide later';

    document.getElementById(
      's-series'
    ).textContent =
      state.series ||
      'Decide at the drop';

    var row =
      document.getElementById(
        's-row-price'
      );

    if (state.price > 0) {
      row.hidden = false;

      document.getElementById(
        's-price'
      ).textContent =
        'from ' +
        money(state.price);
    } else {
      row.hidden = true;
    }
  }


  function show(n) {
    cur = n;

    steps.forEach(
      function (s) {
        s.classList.toggle(
          'on',
          +s.getAttribute(
            'data-step'
          ) === n
        );
      }
    );

    bars.forEach(
      function (b, i) {
        b.classList.toggle(
          'on',
          i < n
        );
      }
    );

    mSub.textContent =
      'Step ' +
      n +
      ' of 3 · takes about 20 seconds';

    btnBack.hidden =
      n === 1;

    btnNext.innerHTML =
      n === 3
        ? 'Pay ' +
          money(
            PEEPERLY.tokenAmount
          ) +
          ' at checkout <span class="arw">&rarr;</span>'
        : 'Continue <span class="arw">&rarr;</span>';

    if (n === 3) {
      fillSummary();
    }
  }
/* ============================================================
   GOKWIK CHECKOUT
   ------------------------------------------------------------
   IMPORTANT:
   - GoKwik snippet is NOT modified.
   - Only ONE GoKwik button exists on the page.
   - Single / Bundle changes the Shopify variant used
     by that one original GoKwik form.
   ============================================================ */

var gkHolder =
  document.getElementById(
    'peeperly-gokwik-holder'
  );

var gkForm =
  document.getElementById(
    'pb-gokwik-form'
  );

var gkVariant =
  document.getElementById(
    'pb-gokwik-variant'
  );

var gkModel =
  document.getElementById(
    'pb-gokwik-model'
  );

var gkSeries =
  document.getElementById(
    'pb-gokwik-series'
  );

var gkPrice =
  document.getElementById(
    'pb-gokwik-price'
  );

var gkBundle =
  document.getElementById(
    'pb-gokwik-bundle'
  );


/* ------------------------------------------------------------
   PRODUCT VARIANTS
   ------------------------------------------------------------ */

var GK_SINGLE_VARIANT =
  gkHolder
    ? gkHolder.getAttribute(
        'data-single-variant'
      )
    : '';

var GK_BUNDLE_VARIANT =
  gkHolder
    ? gkHolder.getAttribute(
        'data-bundle-variant'
      )
    : '';


/* ------------------------------------------------------------
   Get the ORIGINAL GoKwik button.
   We never clone it and never change its ID.
   ------------------------------------------------------------ */

function getGkButton() {

  if (!gkForm) {
    return null;
  }

  var button =
    gkForm.querySelector(
      '.gokwik-buy-now-trigger'
    );

  if (button) {
    return button;
  }

  button =
    gkForm.querySelector(
      '#gokwik-buy-now'
    );

  if (button) {
    return button;
  }

  button =
    gkForm.querySelector(
      '[onclick*="onBuyNowClick"]'
    );

  return button || null;
}


/* ------------------------------------------------------------
   Reset only our own UI state.

   DO NOT clone GoKwik button.
   DO NOT replace GoKwik button.
   DO NOT change GoKwik button ID.
   ------------------------------------------------------------ */

function resetGkButton() {

  var button =
    getGkButton();

  if (!button) {
    return;
  }

  try {
    button.disabled = false;
  } catch (e) {}

  button.removeAttribute(
    'aria-disabled'
  );

  button.classList.remove(
    'loading',
    'is-loading',
    'disabled',
    'processing'
  );

  var loader =
    button.querySelector(
      '.addloadr'
    );

  if (loader) {
    loader.style.display = 'none';
  }

  var text =
    button.querySelector(
      '.btn-text'
    );

  if (text) {
    text.style.display = '';
  }
}


/* ------------------------------------------------------------
   Reset Peeperly checkout state
   ------------------------------------------------------------ */

function resetGoKwikState() {

  resetGkButton();

  if (btnNext) {

    btnNext.disabled = false;

    btnNext.innerHTML =
      cur === 3
        ? 'Pay ' +
          money(
            PEEPERLY.tokenAmount
          ) +
          ' at checkout <span class="arw">&rarr;</span>'
        : 'Continue <span class="arw">&rarr;</span>';
  }
}


/* ------------------------------------------------------------
   Set the ACTIVE Shopify product
   ------------------------------------------------------------ */

function setGkProduct(
  isBundle
) {

  if (!gkForm || !gkVariant) {
    return false;
  }

  var variant =
    isBundle
      ? GK_BUNDLE_VARIANT
      : GK_SINGLE_VARIANT;

  if (!variant) {

    console.error(
      '[Peeperly] Missing ' +
      (
        isBundle
          ? 'Bundle'
          : 'Single'
      ) +
      ' variant.'
    );

    return false;
  }


  /*
   * THIS is the important part:
   *
   * The SAME GoKwik form is used,
   * but its Shopify product variant is
   * changed before GoKwik is triggered.
   */

  gkVariant.value =
    String(variant);


  /*
   * Make sure Shopify sees the current
   * variant as the selected option.
   */

  gkVariant.setAttribute(
    'value',
    String(variant)
  );


  /*
   * Update form data if the theme/GoKwik
   * checks it.
   */

  gkForm.setAttribute(
    'data-product-variant',
    String(variant)
  );


  console.log(
    '[Peeperly] Active product:',
    isBundle
      ? 'BUNDLE'
      : 'SINGLE'
  );

  console.log(
    '[Peeperly] Active variant:',
    variant
  );


  return true;
}


/* ------------------------------------------------------------
   Set line-item properties
   ------------------------------------------------------------ */

function prepareGkForm(
  isBundle
) {

  if (!gkForm) {
    return;
  }


  var quantity =
    gkForm.querySelector(
      'input[name="quantity"]'
    );

  if (quantity) {
    quantity.value = '1';
  }


  if (gkModel) {
    gkModel.value =
      state.model ||
      'Decide later';
  }


  if (gkSeries) {
    gkSeries.value =
      state.series ||
      'Decide at the drop';
  }


  if (gkPrice) {
    gkPrice.value =
      '₹199';
  }


  if (gkBundle) {
    gkBundle.value =
      isBundle
        ? 'Yes - Case + Power Bank + AirPods Case'
        : 'No';
  }
}


/* ------------------------------------------------------------
   CHECKOUT
   ------------------------------------------------------------ */

function toCheckout() {

  /*
   * Bundle is determined ONLY from the
   * current booking button:
   *
   * data-set="1" = Bundle
   * no data-set   = Single
   */

  var isBundle =
    state.wantsSet === true;

  var productName =
    isBundle
      ? 'prebook-bundle-token'
      : 'pre-book-token-1';


  if (!gkForm) {

    console.error(
      '[Peeperly] GoKwik form not found.'
    );

    resetGoKwikState();

    return;
  }


  /*
   * Select correct Shopify product.
   */

  if (
    !setGkProduct(
      isBundle
    )
  ) {

    resetGoKwikState();

    return;
  }


  /*
   * Fill properties AFTER selecting product.
   */

  prepareGkForm(
    isBundle
  );


  /*
   * Verify final variant.
   */

  var finalVariant =
    gkVariant
      ? gkVariant.value
      : '';


  if (!finalVariant) {

    console.error(
      '[Peeperly] Final variant is empty.'
    );

    resetGoKwikState();

    return;
  }


  console.log(
    '================================'
  );

  console.log(
    '[Peeperly] GoKwik checkout'
  );

  console.log(
    '[Peeperly] Product:',
    productName
  );

  console.log(
    '[Peeperly] Variant:',
    finalVariant
  );

  console.log(
    '[Peeperly] Bundle:',
    isBundle
  );

  console.log(
    '================================'
  );


  /*
   * Remove saved modal draft.
   */

  try {
    localStorage.removeItem(
      DRAFT
    );
  } catch (e) {}


  btnNext.disabled = true;

  btnNext.textContent =
    'Taking you to checkout…';


  /*
   * Clear previous abandoned checkout.
   */

  fetch(
    '/cart/clear.js',
    {
      method: 'POST',
      credentials: 'same-origin'
    }
  )
    .catch(
      function (err) {

        console.error(
          '[Peeperly] Cart clear failed:',
          err
        );

      }
    )
    .then(
      function () {

        /*
         * Give Shopify a moment to finish
         * clearing the old cart.
         */

        setTimeout(
          function () {

            try {

              /*
               * Set product ONE MORE TIME
               * immediately before GoKwik.
               *
               * This prevents the previous
               * Single/Bundle selection from
               * being reused.
               */

              if (
                !setGkProduct(
                  isBundle
                )
              ) {

                throw new Error(
                  'Unable to set selected product.'
                );

              }


              prepareGkForm(
                isBundle
              );


              /*
               * Get the SAME original
               * GoKwik button.
               */

              var button =
                getGkButton();


              if (!button) {

                throw new Error(
                  'GoKwik button not found.'
                );

              }


              /*
               * Do NOT:
               * - clone
               * - replace
               * - rename ID
               * - call onBuyNowClick manually
               */

              console.log(
                '[Peeperly] Triggering original GoKwik button for:',
                productName
              );


              /*
               * Native click lets the original
               * GoKwik snippet handle everything.
               */

              button.click();


            } catch (error) {

              console.error(
                '[Peeperly] GoKwik checkout failed:',
                error
              );

              resetGoKwikState();

            }

          },
          250
        );

      }
    );
}

  /* ============================================================
     OPEN / CLOSE
     ============================================================ */

  function open(opts) {

    opts =
      opts || {};


    /*
     * VERY IMPORTANT:
     *
     * If user previously opened GoKwik and exited,
     * clear its old loading/disabled state before
     * opening the Peeperly modal again.
     */
    resetGoKwikState();


    lastFocus =
      document.activeElement;


    if (opts.series) {

      state.series =
        opts.series;

      var src =
        document.querySelector(
          '#pick-series .opt-btn[data-val="' +
            opts.series +
            '"]'
        );

      state.price =
        src
          ? +src.getAttribute(
              'data-price'
            )
          : 0;

      save();
    }


    /*
     * IMPORTANT:
     * This is freshly calculated every time the
     * user clicks Single / Bundle.
     */
    state.wantsSet =
      !!opts.set;

    save();


    paint(
      'pick-model',
      state.model
    );

    paint(
      'pick-series',
      state.series
    );


    ov.classList.add(
      'open'
    );

    document.body.classList.add(
      'peeperly-scroll-lock'
    );


    show(1);


    setTimeout(
      function () {

        var f =
          ov.querySelector(
            '.step.on .opt-btn'
          );

        if (f) {
          f.focus();
        }

      },
      260
    );
  }


  function close() {

    ov.classList.remove(
      'open'
    );


    /*
     * Reset everything when the Peeperly
     * modal is closed.
     */
    resetGoKwikState();


    document.body.classList.remove(
      'peeperly-scroll-lock'
    );


    if (lastFocus) {

      try {
        lastFocus.focus();
      } catch (e) {}

    }
  }
    /* ---------- BOOK BUTTONS ---------- */

  [].forEach.call(
    document.querySelectorAll(
      '[data-book]'
    ),
    function (b) {

      b.addEventListener(
        'click',
        function () {

          /*
           * Always reset old checkout state
           * before opening a fresh booking.
           */
          resetGoKwikState();

          open({
            series:
              b.getAttribute(
                'data-series'
              ),

            set:
              b.hasAttribute(
                'data-set'
              )
          });

        }
      );
    }
  );


  document
    .getElementById('m-close')
    .addEventListener(
      'click',
      close
    );


  ov.addEventListener(
    'mousedown',
    function (e) {

      if (e.target === ov) {
        close();
      }

    }
  );


  document.addEventListener(
    'keydown',
    function (e) {

      if (
        e.key === 'Escape' &&
        ov.classList.contains(
          'open'
        )
      ) {

        close();

      }

    }
  );


  /* ---------- MODEL ---------- */

  document
    .getElementById(
      'pick-model'
    )
    .addEventListener(
      'click',
      function (e) {

        var b =
          e.target.closest(
            '.opt-btn'
          );

        if (!b) return;


        state.model =
          b.getAttribute(
            'data-val'
          );

        save();


        paint(
          'pick-model',
          state.model
        );


        setTimeout(
          function () {
            show(2);
          },
          140
        );
      }
    );


  /* ---------- SERIES ---------- */

  document
    .getElementById(
      'pick-series'
    )
    .addEventListener(
      'click',
      function (e) {

        var b =
          e.target.closest(
            '.opt-btn'
          );

        if (!b) return;


        var v =
          b.getAttribute(
            'data-val'
          );


        state.series =
          v ===
          'Show me everything'
            ? ''
            : v;


        state.price =
          +b.getAttribute(
            'data-price'
          ) || 0;


        save();


        paint(
          'pick-series',
          v
        );


        setTimeout(
          function () {
            show(3);
          },
          140
        );
      }
    );


  /* ---------- NEXT ---------- */

  btnNext.addEventListener(
    'click',
    function () {

      if (cur === 1) {

        if (!state.model) {

          state.model =
            'Decide later';

          save();

        }

        show(2);

        return;
      }


      if (cur === 2) {

        show(3);

        return;
      }


      toCheckout();

    }
  );


  /* ---------- BACK ---------- */

  btnBack.addEventListener(
    'click',
    function () {

      if (cur > 1) {

        show(
          cur - 1
        );

      }

    }
  );


  /* ---------- ENTER ---------- */

  ov.addEventListener(
    'keydown',
    function (e) {

      if (
        e.key === 'Enter'
      ) {

        e.preventDefault();

        btnNext.click();

      }

    }
  );

})();